import React, { useEffect } from 'react';
import { SubmarkLogo } from './Icons';
import { TERMS_OF_SERVICE } from '../../config/legalContent';
import { LegalDocument } from '../../components/LegalDocument';

export const TermsOfServicePage: React.FC = () => {
    // Set page title for SEO
    useEffect(() => {
        document.title = 'UniversityTech.io | Terms of Service';
        
        // Add meta description
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', 'Terms of Service for UniversityTech.io - Read our terms and conditions for using the technology transfer platform.');
        }
    }, []);

    return (
        <div className="min-h-screen bg-[#FCFBF9] font-space-grotesk">
            {/* Header */}
            <header className="px-4 sm:px-8 lg:px-16 py-4 border-b border-primary-200 bg-white/80 backdrop-blur-sm sticky top-0 z-10">
                <div className="max-w-7xl mx-auto flex justify-between items-center">
                    <a href="/" className="cursor-pointer">
                        <SubmarkLogo />
                    </a>
                    <a 
                        href="/"
                        className="px-4 py-2 text-sm font-medium text-main-text bg-grayscale-100 border border-primary-600 rounded-full hover:bg-primary-100 transition-colors"
                    >
                        ← Back to Home
                    </a>
                </div>
            </header>

            {/* Main Content */}
            <main className="px-4 sm:px-8 lg:px-16 py-8 sm:py-12">
                <div className="max-w-4xl mx-auto">
                    {/* Content Card */}
                    <div className="bg-grayscale-100 rounded-2xl shadow-custom-light p-6 sm:p-10">
                        {/* Header */}
                        <div className="border-b border-grayscale-800 pb-6 mb-8">
                            <h1 className="text-grayscale-1300 font-grotesk text-2xl sm:text-3xl font-medium">
                                Terms of Service
                            </h1>
                        </div>

                        {/* Content */}
                        <div className="flex flex-col gap-6 text-grayscale-1200 font-grotesk">
                            <LegalDocument doc={TERMS_OF_SERVICE} />
                        </div>

                        {/* Footer Links */}
                        <div className="mt-10 pt-6 border-t border-grayscale-300 flex flex-wrap gap-4 justify-center text-sm text-grayscale-900">
                            <a href="/privacy-policy" className="text-primary-600 hover:text-primary-700 underline">Privacy Policy</a>
                            <span>•</span>
                            <a href="mailto:info@universitytech.io" className="text-primary-600 hover:text-primary-700 underline">Contact Us</a>
                            <span>•</span>
                            <a href="/" className="text-primary-600 hover:text-primary-700 underline">Back to Home</a>
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="px-4 sm:px-8 lg:px-16 py-6 border-t border-primary-200 bg-white/50">
                <div className="max-w-7xl mx-auto text-center text-sm text-grayscale-900">
                    <p>© {new Date().getFullYear()} UniversityTech.io — Operated by Paragise Private Limited</p>
                </div>
            </footer>
        </div>
    );
};

